import { render, staticRenderFns } from "./D3.vue?vue&type=template&id=47add1ce&"
import script from "./D3.vue?vue&type=script&lang=js&"
export * from "./D3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports